import { AxiosResponse } from 'axios';

import { NewActivity } from 'types';
import { UserGender } from 'types/enums/UserGender';
import { UserCard } from 'types/interfaces/user/UserCard';
import { UserVideoCard } from 'types/interfaces/user/UserVideoCard';

import { deserializeFilters } from './deserialization/finderApi';
import { httpClient } from './httpClient';
import { serializeFilters } from './serialization/finderApi';

export type FinderFilters = {
  gender: UserGender;
  city: {
    label: string;
    value: number;
  };
  age_from: number;
  age_to: number;
  marital_statuses?: number[];
  preference_tags?: number[];
  ethnicities?: number[];
  body_types?: number[];
};

export type FetchPublicUsersResponse = {
  next: string | null;
  data: UserCard[];
  sympathies: NewActivity;
  profiles_pack_hash: string;
};

export type FetchTopProposalResponse = {
  data: UserCard[];
  profiles_pack_hash: string;
};

export type FirstFetchPublicUsersResponse = FetchPublicUsersResponse & {
  params: FinderFilters;
};

export type FetchPublicUsersPayload = {
  filters: FinderFilters;
  url?: string;
};

export interface FinderVideo {
  id: number;
  username: string;
  age: number;
  gender: string;
  is_popular: boolean;
  profile_photo_url: string;
  video_id: number;
  video_url: string;
}

export type FetchVideoCastPagePayload = {
  url?: string;
  filters: FinderFilters;
};

export type FetchVideoCastPageResponse = {
  data: UserVideoCard[];
  next: string | null;
  profiles_pack_hash: string;
};

export type FirstFetchVideoCastPageResponse = FetchVideoCastPageResponse & {
  params: FinderFilters;
};

export const FinderApi = {
  async firstFetchPublicUsers() {
    const response = await httpClient.get('/finder/find-first');

    return {
      ...response,
      data: {
        ...response.data,
        params: deserializeFilters(response.data.params),
      },
    } as AxiosResponse<FirstFetchPublicUsersResponse>;
  },

  async fetchTopProposal() {
    const response = await httpClient.get('/finder/top-proposal');

    return {
      ...response,
      data: {
        ...response.data,
      },
    } as AxiosResponse<FetchTopProposalResponse>;
  },

  async fetchPublicUsers(payload: FetchPublicUsersPayload) {
    const { url, filters } = payload;

    return httpClient.post<FetchPublicUsersResponse>(
      url || '/finder/find/1',
      serializeFilters(filters)
    );
  },

  async fetchFirstVideoCastPage() {
    const { data } = await httpClient.get('/finder/cam-video/find-first');

    return {
      ...data,
      params: deserializeFilters(data.params),
    } as FirstFetchVideoCastPageResponse;
  },

  async fetchVideoCastPage(payload: FetchVideoCastPagePayload) {
    const { url, filters } = payload;

    const { data } = await httpClient.post<FetchVideoCastPageResponse>(
      url || '/finder/cam-video/find/1',
      serializeFilters(filters)
    );

    return data;
  },

  async fetchRandomUserWithVideo() {
    const { data } = await httpClient.get<FinderVideo>(
      '/finder/pic-in-pic/random'
    );

    return data;
  },
};
